import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { MonthlySummary } from '../../types/report';

ChartJS.register(ArcElement, Tooltip, Legend);

interface ProfessionalVsPersonalChartProps {
  data: MonthlySummary;
}

export const ProfessionalVsPersonalChart: React.FC<ProfessionalVsPersonalChartProps> = ({
  data,
}) => {
  const chartData = {
    labels: ['Professional', 'Personal', 'Pending'],
    datasets: [
      {
        data: [data.professional_km, data.personal_km, data.pending_km],
        backgroundColor: ['#70AD47', '#FFC000', '#D1D5DB'],
        borderColor: ['#70AD47', '#FFC000', '#D1D5DB'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
            return `${label}: ${value} km (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: '300px' }}>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};
